const mediaQueries = {
  small_phone: '@media (max-width: 320px)',
  phone: '@media (max-width: 599px)',
  phone_landscape: '@media (max-width: 767px) and (orientation: landscape)',
  phone_tablet: '@media (max-width: 1024px)',
  tablet: '@media (min-width: 600px) and (max-width: 1024px)',
  tablet_landscape: '@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)',
  tablet_up: '@media (min-width: 768px)',
  tablet_big_up: '@media (min-width: 992px)',
  tablet_big_down: '@media (max-width: 600px)',
  tablet_big_down_world_cup: '@media (max-width: 767px)',
  tablet_big_down_team_next_widget: '@media (max-width: 767px)',
  small_desktop: '@media (min-width: 1025px) and (max-width: 1280px)',
  small_desktop_tablet: '@media (min-width: 992px) and (max-width: 1280px)',
  small_desktop_down: '@media (max-width: 1439px)',
  small_desktop_up: '@media (min-width: 1439px)',
  desktop: '@media (min-width: 1025px)',
  big_desktop: '@media (min-width: 1408px)',
};

export default mediaQueries;



// WEBPACK FOOTER //
// ./src/theme/corriere/mediaQueries.js